import { render, staticRenderFns } from "./scaleEdit.vue?vue&type=template&id=016d8f88"
import script from "./scaleEdit.vue?vue&type=script&lang=js"
export * from "./scaleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports